import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import './chooseUserOption.css';

const ChooseUserOption = (props) => {
    let hintMsg;
    if(props.hintMsg){
        hintMsg = props.hintMsg
    }

    const handleChange = (e) => {

        
            

        if (props.idUsers != undefined) {
        
            props.onCheck(props.idUsers, props.option);
            localStorage.setItem('participantUsersID', props.idUsers);
            localStorage.setItem('userName', props.userName);
        }
        if (props.paymentOption != undefined) {
            props.onCheck(props.paymentOption);
        }

        if (props.paymentOption == undefined && props.idUsers == undefined) {
            props.onCheck();
        }
    };

    return (
        <>
            <div className="iconCheckLabel">
                <div onClick={handleChange} className="iconCheckWrapper">
                    {props.isChekcked ? (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="iconChecked"
                            fill="#cc0033"
                            viewBox="-4 0 36 36"
                            title="sprawdzam"
                        >
                            {hintMsg != undefined?<title>{hintMsg}</title>:""}
                            <path
                                strokeWidth="5"
                                d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z"
                            />
                            <path d="m13 20.59-4.29-4.3-1.42 1.42 5 5a1 1 0 0 0 1.41 0l11-11-1.41-1.41z" />
                        </svg>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="iconChecked"
                            fill="#cc0033"
                            viewBox="-4 0 36 36"
                            title="sprawdzam"
                        >
                            {hintMsg != undefined?<title>{hintMsg}</title>:""}
                            <path d="M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14z" />
                        </svg>
                    )}{' '}
                </div>
                <label>{props.label}</label>
            </div>
        </>
    );
};

export default ChooseUserOption;
